import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { AboRegistrationBoxComponent } from './abo-registration/abo-registration-box.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, HomeRoutingModule, TranslateModule.forChild(), SharedModule, FormsModule],
  declarations: [HomeComponent, AboRegistrationBoxComponent],
  bootstrap: []
})
export class HomeModule {}
